import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@reach/router';
import { UncontrolledTooltip as Tooltip } from 'reactstrap';
import { I18N } from 'commons';

const Header = ({ priority, id, title }) => (
  <div className="col-sm-12">
    <Link
      to="../"
      eb-test="ee_notificationDetail_link_back"
    >
      &laquo;&nbsp;<I18N>notification.link.back</I18N>
    </Link>
    <span className="vertical-line">|</span>
    <h2 eb-test="ee_notificationDetail_text_title">
      {priority && (
        <i
          id={`icon_priority_${id}`}
          className="priority fas fa-exclamation-triangle"
          aria-hidden="true"
        />
      )}
      {priority && (
        <Tooltip placement="top" target={`icon_priority_${id}`}>
          <I18N>notification.title.priority</I18N>
        </Tooltip>
      )}
      {title}
    </h2>
  </div>
);

Header.propTypes = {
  priority: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Header;
